import * as React from "react";
import type { SVGProps } from "react";
const SvgSun = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12 7a1 1 0 0 1-1-1V3a1 1 0 0 1 2 0v3a1 1 0 0 1-1 1Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm0-6a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M11.293 21.707A1 1 0 0 0 13 21v-3a1 1 0 0 0-2 0v3a1 1 0 0 0 .293.707ZM6 13H3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2ZM18 13h3a1 1 0 0 0 0-2h-3a1 1 0 0 0 0 2ZM5.64 19.36a1.002 1.002 0 0 1-.71-.29 1 1 0 0 1 0-1.41l2.12-2.12a1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.41l-2.12 2.12a1 1 0 0 1-.7.29ZM15.54 8.46a1 1 0 0 0 .7.3 1 1 0 0 0 .76-.3l2.07-2.12a1 1 0 0 0 0-1.41 1 1 0 0 0-1.41 0l-2.12 2.12a1 1 0 0 0 0 1.41ZM18.36 19.36a1 1 0 0 1-.7-.29L15.54 17a1 1 0 0 1 0-1.41 1 1 0 0 1 1.41 0l2.12 2.12a1 1 0 0 1 0 1.41 1 1 0 0 1-.71.24ZM7.375 8.681a1 1 0 0 0 .385.079 1 1 0 0 0 .7-.3 1 1 0 0 0 0-1.41L6.34 4.93a1 1 0 0 0-1.41 0 1 1 0 0 0 0 1.41l2.12 2.12a1 1 0 0 0 .325.221Z"
    />
  </svg>
);
export default SvgSun;
